import { render } from "./MultipleSelect.vue?vue&type=template&id=67e25aaa"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"
script.render = render

export default script